export const HOME = 'HOME';
export const DETAIL = 'DETAIL';
export const LANDING = 'LANDING';
export const ERROR = 'ERROR';

export const LPA_HOME = 'LPA_HOME';
export const LPA_DETAIL = 'LPA_DETAIL';

// customer
export const SHOP_INDEX = 'SHOP_INDEX';
export const SHOP_ERROR_INDEX = 'SHOP_ERROR_INDEX';

export const APP_STORAGE_WEB_KEY = 'mobile_shop_app';
export const APP_STORAGE_LANGUAGE_KEY = 'mobile_language_app';